import React, { PureComponent } from 'react';
import LayoutConstraint from '~/UI/LayoutConstraint/LayoutConstraint';
import Popover, { Position, Styles } from '~/UI/Popover';

import defaultStyles from './default.less';

interface Props {
	reference: React.ReactElement;
	children: React.ReactNode;
	width: number | null;
	position: Position;
	styles: Styles;
}

interface State {
	show: boolean;
}

let CurrentTooltip: { hide(): void } | null = null;

export default class Tooltip extends PureComponent<Props, State> {
	static defaultProps = {
		width: null,
		position: 'top',
		styles: defaultStyles,
	};

	state = {
		show: false,
	};

	hideTimeout: NodeJS.Timeout | null = null;

	componentWillUnmount() {
		if (CurrentTooltip === this) {
			CurrentTooltip = null;
		}
		this.clearHideTimeout();
	}

	componentDidUpdate(prevProps: Props, prevState: State) {
		if (!prevState.show && this.state.show && CurrentTooltip !== this) {
			if (CurrentTooltip !== null) {
				CurrentTooltip.hide();
			}
			/* eslint-disable @typescript-eslint/no-this-alias */
			CurrentTooltip = this;
		}
	}

	render() {
		const {
			props: { reference, children, width, position, styles },
			state: { show },
		} = this;

		return (
			<span onMouseEnter={this.mouseEntered} onMouseLeave={this.mouseLeft}>
				<LayoutConstraint reference={reference}>
					{({ referenceRect }) =>
						show ? (
							<Popover
								position={position}
								referenceRect={referenceRect}
								styles={styles}
								width={width}
								onClose={() => undefined}
								onMouseEnter={this.mouseEntered}
								onMouseLeave={this.mouseLeft}
							>
								{children}
							</Popover>
						) : null
					}
				</LayoutConstraint>
			</span>
		);
	}

	mouseEntered = () => {
		this.clearHideTimeout();
		this.setState({ show: true });
	};

	mouseLeft = () => {
		this.clearHideTimeout();
		this.hideTimeout = setTimeout(() => this.setState({ show: false }), 300);
	};

	hide() {
		this.clearHideTimeout();
		this.setState({ show: false });
	}

	clearHideTimeout() {
		if (this.hideTimeout !== null) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}
	}
}
